import { renderDropdownAction } from '..';
import { InterviewListItem } from '../../../entities/InterviewListItem';
import { addReturnTitle } from '../../../utils/applicant_tracking/actions/schedulingActions';
import { appendRedirectUri } from '../../../utils/url';
import { shouldActionBeVisible } from './index';

function getTitle(isLinkExpired: boolean): string {
  if (isLinkExpired) return 'Regenerate self-scheduling link';

  return 'Edit Availability';
}

function getIcon(isLinkExpired: boolean): string {
  if (isLinkExpired) return 'bi-arrow-repeat';

  return 'bi-pencil';
}

export function editAvailability(
  interview: InterviewListItem,
  returnTitle = 'Interviews',
) {
  if (!shouldActionBeVisible(interview)) return null;

  return renderDropdownAction(
    getTitle(interview.interviewCandidateUser.isExpired),
    getIcon(interview.interviewCandidateUser.isExpired),
    interview.interviewCandidateUser.isRejected,
    () => {
      let path = `/applicant_tracking/interview_candidate_users/${interview.interviewCandidateUser.id}/edit?`;

      path = addReturnTitle(path, returnTitle);
      const uri = appendRedirectUri(path);
      window.location.href = uri;
    },
  );
}
